export default function initForms() {
    const wpcf7Forms = [].slice.call(document.querySelectorAll('.wpcf7'));

    wpcf7Forms.forEach((form) => {
        const input = form.querySelector('input[name="sent-from"]');

        if (!input) {
            return;
        }

        input.value = window.location.href;
    })

    initModalForms();
}

function initModalForms() {
    const modalEl = document.getElementById('themeModalForms');

    if (!modalEl) {
        return;
    }

    const formToggleEls = [].slice.call(document.querySelectorAll('.js-formToggle'));
    const closeButtonEl = modalEl.querySelector('.closeButton');

    formToggleEls.forEach(toggle => {
        const formId = toggle.dataset.formId;
        const formType = toggle.dataset.formType;

        toggle.addEventListener('click', () => {
            openForm(formId, formType);
        })
    })

    closeButtonEl.addEventListener('click', () => {
        closeForm();
    })

    function openForm(id, type) {

        if (type === 'formset') {
            activateForm(id);
            modalEl.querySelector('.themeFormset').classList.add('is-active');
        } else {
            modalEl.querySelector(`.themeForm[data-form-id="${id}"]`).classList.add('is-active');
        }

        modalEl.classList.add('is-active');
    }

    function closeForm() {
        modalEl.querySelectorAll('.themeForm, .themeFormset').forEach(form => form.classList.remove('is-active'));
        modalEl.classList.remove('is-active');
    }

    function activateForm(formId) {
        const radioInputs = [].slice.call(modalEl.querySelectorAll('input[type="radio"]'));
        const formWrappers = [].slice.call(modalEl.querySelectorAll('.themeFormset-formWrapper'));

        formWrappers.forEach(wrapper => wrapper.classList.remove('is-active'));

        radioInputs.find((input) => {
            return input.value === formId;
        }).checked = true;

        formWrappers.find((wrapper) => {
            return wrapper.dataset.formId === formId;
        }).classList.add('is-active');
    }
}
